import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { trackWebVitals, trackSearchReferrer } from './seoAnalyticsService';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Track search referrers on page load
trackSearchReferrer();

// Report Web Vitals to analytics
reportWebVitals(trackWebVitals);
